import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TinymedicPatientOrder from './tinymedic-patient-order';
import TinymedicPatientOrderDetail from './tinymedic-patient-order-detail';
import TinymedicPatientOrderUpdate from './tinymedic-patient-order-update';
import TinymedicPatientOrderDeleteDialog from './tinymedic-patient-order-delete-dialog';

const TinymedicPatientOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TinymedicPatientOrder />} />
    <Route path="new" element={<TinymedicPatientOrderUpdate />} />
    <Route path=":id">
      <Route index element={<TinymedicPatientOrderDetail />} />
      <Route path="edit" element={<TinymedicPatientOrderUpdate />} />
      <Route path="delete" element={<TinymedicPatientOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TinymedicPatientOrderRoutes;
